/**
 * Runtime configuration.
 *
 * The app is one static bundle for every environment; environment-specific
 * values live in /config.json, rendered next to the bundle by
 * scripts/sync-config.mjs from the repo's build/config.<env>.json. Fields:
 * environment, productName, apiGatewayUrl, domain, oauthProviders.
 *
 * loadConfig() is called once in main.jsx before the first render, so
 * getConfig() is synchronous everywhere else.
 */
let config = null;

export async function loadConfig() {
  const response = await fetch('/config.json', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Failed to load /config.json (HTTP ${response.status})`);
  }
  config = await response.json();
  return config;
}

export function getConfig() {
  if (!config) {
    throw new Error('Config not loaded yet — loadConfig() must run first');
  }
  return config;
}
